import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Input, Select} from 'antd';
import uuidv1 from 'uuid/v1';

@autobind
/**
 *
 */
export default class Tools extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    onChangeListItemInput: PropTypes.func,
    onChangeListItemSelect: PropTypes.func,
    onDeleteItem: PropTypes.func,
    option: PropTypes.bool,
  };
  static defaultProps = {
    items: [],
    option: true,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
  }

  /**
   *
   */
  componentDidMount() {
  }


  _renderItemList() {
    const {items} = this.props;
    let list = [];
    list.push(<Select.Option key="null" value="null">Null</Select.Option>);
    app._.map(items, (item) => {
      list.push(<Select.Option key={item.dataIndex} value={item.dataIndex}>{item.title}</Select.Option>);
    });
    return list;
  }


  _onChangeAdd(value) {
    this.setState({changeAdd: value});
  }


  _findTitle() {
    let {items} = this.props;
    let {changeAdd} = this.state;
    let _item = items.find((item) => item.dataIndex === changeAdd);

    return _item ? _item.title : 'NULL';
  }

  _onAdd() {
    let {changeAdd, items} = this.state;

    this.setState({
      items: [
        {
          dataKey: uuidv1(),
          dataIndex: changeAdd,
          title: this._findTitle(),
        },
        ...items,
      ],
    });
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {items} = this.props;
    return (
      <Input.Group compact>
        <Select
          style={{width: '200px'}}
          defaultValue="null"
          onChange={this._onChangeAdd}
        >
          {this._renderItemList()}
        </Select>
        <MaterialIcon
          className="add"
          style={{
            background: '#009fff',
            color: '#fff',
            fontSize: '1.1rem',
            padding: '0 3px',
          }}
          name="plus"
          onClick={this._onAdd}
        />
      </Input.Group>
    );
  }
}
